import { t, Trans } from '@lingui/macro';
import { NoddiDummyButton } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useBookingActions } from '../../pages/BookingFlow/bookingStore';

export const WheelChangeImageCard = ({ cardText }: { cardText: string }) => {
  const { clearStore } = useBookingActions();

  return (
    <NoddiBasicCard
      onClick={clearStore}
      to={customerRoutes.newBookingAddress.getPath()}
      className='flex flex-col gap-3 overflow-hidden p-0'
    >
      <img src='/assets/images/wc.jpg' alt={t`Noddi wheel change`} />

      <div className='flex flex-col gap-3 px-6 pb-4'>
        <p>{cardText} 💜</p>
        <NoddiDummyButton endIcon='ArrowRight' className='w-full'>
          <Trans>New booking</Trans>
        </NoddiDummyButton>
      </div>
    </NoddiBasicCard>
  );
};
